import React, { Component } from 'react'
import FileSaver from 'file-saver'
import Reader from '../../controller/Reader'
import Deleter from '../../controller/Deleter'
import Updater from '../../controller/Updater'
import Creater from '../../controller/Creater'

export default class MemoDetail extends Component {

    constructor(props) {
        super(props)
        this.state = {
            catg1: '',
            catg2: '',
            title: '',
            content: '',
            heart: '',
            upload: '',
            downloaded: ''
        }
    }

    componentDidMount() {

        this.getFx()

    }

    
    getFx = () => {

        if(this.props.idName === null) {
            
            return

        }

        const condition = {
            url : '/api/memo/detail/' + this.props.idName,
        }

        Reader(condition, res => {
            this.setState(
                {
                   catg1: res.data.catg1,
                   catg2: res.data.catg2,
                   title: res.data.title,
                   content: res.data.content,
                   heart: res.data.heart,
                   upload: res.data.upload
                }
            )
        })
    }


    changeFx = (e) => {

        this.setState(
            { [e.target.name] : e.target.value }
        )
    }


    deleteFx = (e) => {

        e.preventDefault()

        let condition = {
            url : '/api/memo/delete/' + this.props.idName
        }

        Deleter(condition, res => {
            console.log(res.message)
            this.props.closeMe()
        })
    }


    saveFx = (e) => {

        let condition = {
            url : '/api/memo/update/' + this.props.idName,
            data : {
                catg1: this.state.catg1,
                catg2: this.state.catg2,
                title: this.state.title,
                content: this.state.content,
                heart: this.state.heart,
                upload: this.state.upload
            }
        }

        Updater(condition, res => {

            console.log(res.message)
            this.props.closeMe()
        
        })
        
    }

    heartFx = () => {

        if (this.state.heart === true) {
            this.setState(
                { heart : false }
            )
        } else {
            this.setState(
                { heart : true }
            )
        }
    }

    attachFx = (e) => {
        e.preventDefault()
        e.stopPropagation()

        this.setState(
            {
                upload : this.uploadInput.files[0].name
            }
        )

        const data = new FormData()

        data.append('file', this.uploadInput.files[0])

        let condition = {
            url : '/api/memo/attach',
            data : data
        }

        Creater(condition, res => {
            window.alert(res.message)
        })

    }

    downloadFx = () => {

        let condition = {
            url : '/attach/' + this.state.upload,
            responseType : 'blob'
        }

        Reader(condition, res => {
            FileSaver.saveAs(res.data, this.state.upload)
        })

    }


    closeFx = () => {
        this.props.closeMe()
    }


    render() {

        return (

            <React.Fragment>

                <div className='NightWrapper'>

                    <div className='MemoDetailContainer'>

                        <div className='MemoDetailTitle'>

                        <i className='material-icons' id='blinker' onClick={this.closeFx}>clear</i>

                            <textarea className='MemoTitleArea' name='title' value={this.state.title} onChange={this.changeFx}></textarea>
                            
                            <div style={{padding: '0.5em 0em'}}>
                       
                                <select name='catg2' className='MemoDetailSelect' onChange={this.changeFx}>
                                    <option value='0' selected={this.state.catg2 === '0'}>Not Started</option>
                                    <option value='1' selected={this.state.catg2 === '1'}>In Progress</option>
                                    <option value='2' selected={this.state.catg2 === '2'}>Completed</option>
                                    <option value='3' selected={this.state.catg2 === '3'}>Canceled</option>
                                </select>

                                <i className='material-icons' onClick={this.heartFx} style={{fontSize: '1.2rem', marginLeft: '1rem', verticalAlign: 'middle', cursor: 'pointer', color: this.state.heart ? '#3E2D1F' : '#D3C3B7'}}>favorite</i>
                       
                            </div>

                        </div>

                        <textarea className='MemoContentArea' name='content' value={this.state.content} onChange={this.changeFx}></textarea>
                        
                        <div className='MemoGrayBox'>
                            <span onClick={this.downloadFx}>{this.state.upload}</span>
                            
                            <form onSubmit={this.attachFx}>
                                <input type='file' name='upload' id='upload' ref={(ref) => { this.uploadInput = ref }} />
                                <input type='submit' name='submit' value='Add' style={{background: '#22252C', color: '#AE9A8A', border: 'none', padding: '0.2rem 1rem'}} />
                            </form>
                        </div>


                        <div className='MemoDetailBottom'>

                                <span className='RegBtn' onClick={this.closeFx}>CANCEL</span>
                                <span className='RegBtn' onClick={this.saveFx}>SAVE</span>
                                <span className='RegBtn' onClick={this.deleteFx}>DELETE</span>                      
                        
                        </div>
                        
                    </div>
                </div>

  

        </React.Fragment>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/memo/MemoDetail.js